import { render, staticRenderFns } from "./BulkBuy.vue?vue&type=template&id=b6605980&scoped=true&"
import script from "./BulkBuy.vue?vue&type=script&lang=js&"
export * from "./BulkBuy.vue?vue&type=script&lang=js&"
import style0 from "./BulkBuy.vue?vue&type=style&index=0&id=b6605980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6605980",
  null
  
)

export default component.exports